// extracted by mini-css-extract-plugin
module.exports = {"lightboxItem":"Media_lightboxItem__8591J","image":"Media_image__Sb8J3"};